import * as types from "store/editSession/editSessionTypes";


export function getInvalidateInterviewEmailTemplate(projectId) {
  return {
    type: types.GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_REQUESTED,
    payload: { projectId },
  };
}


export function sendSingle(payload) {
  return {
    type: types.SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE,
    payload: payload,
  };
}

export function getEmailTemplate(
  projectId,
  forReschedule,
  addLink,
  editLink,
  responderLanguage,
  languageName,
  invalidateReschedule,
  hasConferenceLink
) {
  return {
    type: types.GET_EMAIL_TEMPLATE_REQUESTED,
    payload: {
      projectId,
      forReschedule,
      addLink,
      editLink,
      responderLanguage,
      languageName,
      invalidateReschedule,
      hasConferenceLink,
    },
  };
}
